import { z } from 'zod';
import { latitude, localeSchema, longitude } from './common.js';
/**
 * Изменение собственных настроек.
 * Поля `pickup_*` принимаются только у курьера — проверка на сервере.
 * Координаты передаются парой: одна без другой отклоняется.
 *
 * `telegram_id` принимается **только у администратора**. У клиента и курьера
 * он приходит из подписанного `initData` и служит идентификатором входа:
 * разреши его менять — пользователь выдаст себя за другого. Администратор
 * входит по паролю, и его `telegram_id` нужен ровно для одного — получать
 * уведомления в свой чат.
 */
export const updateProfileBody = z
    .object({
    locale: localeSchema.optional(),
    first_name: z.string().trim().min(1).max(100).nullable().optional(),
    telegram_id: z.number().int().positive().nullable().optional(),
    pickup_lat: latitude.nullable().optional(),
    pickup_lon: longitude.nullable().optional(),
    pickup_address_text: z.string().max(500).nullable().optional(),
})
    .refine((v) => {
    const hasLat = v.pickup_lat !== undefined && v.pickup_lat !== null;
    const hasLon = v.pickup_lon !== undefined && v.pickup_lon !== null;
    return hasLat === hasLon;
}, { message: 'Координаты точки сборки указываются парой', path: ['pickup_lat'] });
//# sourceMappingURL=profile.js.map